import MemberSettings from './MemberSettings.component';

export default MemberSettings;
